import urls from './restConstants';
import api from './restApi';

const onlineDocumentsCollection = api.all(urls.onlineDocuments);

export default onlineDocumentsCollection;



// WEBPACK FOOTER //
// ./book/src/commons/rest/onlineDocumentsRest.js